// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error_wrapper__j4O2g","visible":"error_visible__s4qLq","card":"error_card__2BUBm","error":"error_error__2Sgc6","warn":"error_warn__2eqUc","info":"error_info__3Sijp"};